<template>
  <b-modal
    id="modal-tratamiento"
    size="lg"
    hide-footer
    header-class="p-0"
    body-class="pt-0"
  >
    <template #modal-header="{ close }">
      <div class="w-100 modal-header-internacion py-2 px-3 d-flex
        justify-content-between align-items-center">
        <h5 class="mb-0">Detalle Internacion N° {{ getNumeroItemChecked }}</h5>
        <button
          type="button"
          class="close"
          @click="close()"
        >&times;</button>
      </div>
    </template>

    <div v-if="isLoading" class="text-center my-2">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>

    <div v-else>
      <table class="table table-sm mb-0">
        <thead class="thead-light">
          <tr>
            <th style="width:5%" class="text-center">
              <input
                type="checkbox"
                v-model="selectAll"
                @change="onToggleSelectAll"
                class="m-0"
              >
            </th>
            <th style="width:5%" class="text-center">Cant.</th>
            <th>Categoria</th>
            <th style="width:15%" class="text-right">Importe</th>
            <th style="width:8%" class="text-center">Ver</th>
          </tr>
        </thead>
        <tbody
          v-for="(categoria, catIndex) in categorias"
          :key="catIndex"
        >
          <!-- Multiselect: categoria_id vacío o servicios con insumo -->
          <tr
            v-if="categoriaHasMultiselect(categoria)"
            :class="{ 'tr-disabled': !!categoria.disabled }"
          >
            <td class="text-center" style="vertical-align: middle;">
              <input
                type="checkbox"
                class="m-0"
                :checked="categoria.checkInput"
                :disabled="!!categoria.disabled"
                @change="onMultiselectCheck(catIndex, $event.target.checked)"
              >
            </td>
            <td class="text-center" style="vertical-align: middle;">{{ categoria.cantidad }}</td>
            <td>
              <div class="row align-items-center">
                <div class="col-sm-4">
                  {{ categoria.nombre_categoria }}
                  <small
                    v-if="categoria.servicioSelected && categoria.servicioSelected.numero_venta"
                    class="text-muted ml-1"
                  >
                    vc: {{ categoria.servicioSelected.numero_venta }}
                  </small>
                </div>
                <div class="col-sm-8">
                  <multiselect
                    :value="categoria.servicioSelected"
                    :options="categoria.servicios.length > 0
                      ? categoria.servicios : (listaServicios || [])"
                    placeholder="Seleccionar servicio..."
                    label="nombre"
                    track-by="id"
                    select-label=""
                    deselect-label="X"
                    :disabled="!!categoria.disabled"
                    @input="onCategoriaServicioSelected(catIndex, $event)"
                  >
                    <span slot="noResult">Sin Resultados</span>
                    <span slot="noOptions">Lista Vacia</span>
                    <template slot="singleLabel" slot-scope="props">
                      <small>{{ props.option.nombre }}</small>
                    </template>
                    <template slot="option" slot-scope="props">
                      <small>{{ props.option.nombre }}</small>
                    </template>
                  </multiselect>
                </div>
              </div>
            </td>
            <td class="text-right" style="vertical-align: middle;">
              {{ (categoria.servicioSelected
                ? categoria.precio : 0
              ) | numeral('0,0.00') }}
            </td>
            <td></td>
          </tr>

          <!-- Expandable: categorias normales con Ver -->
          <template v-if="!categoriaHasMultiselect(categoria)">
            <tr class="tr-categoria" :class="{ 'tr-disabled': isAllServiciosDisabled(catIndex) }">
              <td class="text-center">
                <input
                  v-if="!categoria.disabled_by_actividad_economica"
                  type="checkbox"
                  class="m-0"
                  :checked="isAllChecked(catIndex)"
                  :indeterminate.prop="isSomeChecked(catIndex)"
                  :disabled="isAllServiciosDisabled(catIndex)"
                  @change="toggleAll(catIndex, $event.target.checked)"
                >
              </td>
              <td class="text-center font-weight-bold">{{ categoria.cantidad }}</td>
              <td class="font-weight-bold">
                {{ categoria.nombre_categoria }}
                <small v-if="getCategoriaVc(catIndex)" class="text-muted ml-1">
                  vc: {{ getCategoriaVc(catIndex) }}
                </small>
              </td>
              <td class="text-right font-weight-bold">
                {{ sumPrecioServicios(catIndex) | numeral('0,0.00') }}
              </td>
              <td class="text-center">
                <b-button
                  size="sm"
                  variant="link"
                  class="p-0"
                  @click="toggleExpanded(catIndex)"
                >
                  {{ categoria.expanded ? 'Ocultar' : 'Ver' }}
                </b-button>
              </td>
            </tr>
            <tr v-if="categoria.expanded">
              <td colspan="5" class="p-0">
                <table class="table table-striped mb-0 table-servicios">
                  <tbody>
                    <tr
                      v-for="(servicio, svcIndex) in categoria.servicios"
                      :key="`${catIndex}-${svcIndex}`"
                      :class="{ 'tr-disabled': servicio.disabled }"
                    >
                      <td style="width:5%" class="text-center">
                        <input
                          type="checkbox"
                          class="m-0"
                          :checked="servicio.checkInput"
                          :disabled="!!servicio.disabled"
                          @change="toggleServicio(catIndex, svcIndex, $event.target.checked)"
                        >
                      </td>
                      <td style="width:8%" class="text-center">{{ servicio.cantidad }}</td>
                      <td>
                        {{ servicio.nombre }}
                        <small v-if="servicio.numero_venta" class="text-muted ml-1">
                          vc: {{ servicio.numero_venta }}
                        </small>
                      </td>
                      <td style="width:15%" class="text-right">
                        {{ servicio.precio | numeral('0,0.00') }}
                      </td>
                      <td style="width:8%"></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div v-if="categorias.length === 0" class="text-center text-muted py-3">
        No hay servicios disponibles.
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-12 text-right">
        <button class="btn btn-outline-dark mr-2" @click="cancelarModal()">
          Cancelar
        </button>
        <button class="btn btn-success" @click="confirmarModal()">
          Guardar
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Multiselect from 'vue-multiselect';
import { util } from '@/plugins/util';

export default {
  name: 'ModalTratamiento',
  components: { Multiselect },
  data() {
    return {
      selectAll: false,
    };
  },
  methods: {
    getCategoriaVc(catIndex) {
      const { servicios } = this.categorias[catIndex];
      const vcs = [...new Set(servicios.map((s) => s.numero_venta).filter((v) => v))];
      return vcs.length > 0 ? vcs.join(', ') : null;
    },
    categoriaHasMultiselect(categoria) {
      return !categoria.categoria_id || Number(categoria.categoria_id) === 8;
    },
    sumPrecioServicios(catIndex) {
      const { servicios } = this.categorias[catIndex];
      return servicios.reduce((sum, s) => sum + (parseFloat(s.precio) || 0), 0);
    },
    isAllServiciosDisabled(catIndex) {
      const { servicios } = this.categorias[catIndex];
      return servicios.length > 0 && servicios.every((s) => !!s.disabled);
    },
    isAllChecked(catIndex) {
      const { servicios } = this.categorias[catIndex];
      return servicios.length > 0 && servicios.every((s) => s.checkInput);
    },
    isSomeChecked(catIndex) {
      const { servicios } = this.categorias[catIndex];
      const count = servicios.filter((s) => s.checkInput).length;
      return count > 0 && count < servicios.length;
    },
    onToggleSelectAll() {
      this.categorias.forEach((cat, catIndex) => {
        if (this.categoriaHasMultiselect(cat)) {
          if (!cat.disabled) {
            this.setCategoriaCheck({ categoriaIndex: catIndex, value: this.selectAll });
          }
        } else if (!cat.disabled_by_actividad_economica) {
          this.setAllServiciosCheck({ categoriaIndex: catIndex, value: this.selectAll });
        }
      });
    },
    toggleAll(catIndex, value) {
      this.setAllServiciosCheck({ categoriaIndex: catIndex, value });
    },
    toggleServicio(catIndex, svcIndex, value) {
      this.setServicioCheck({ categoriaIndex: catIndex, servicioIndex: svcIndex, value });
    },
    async onCategoriaServicioSelected(catIndex, value) {
      this.setCategoriaServicioSelected({ categoriaIndex: catIndex, value });
      this.setActividadEconomicaId(value?.actividad_economica_id ?? 0);
      if (value && !this.categorias[catIndex].precio) {
        await this.fetchPrecioServicioSeleccionado({ categoriaIndex: catIndex, servicio: value });
      }
    },
    onMultiselectCheck(catIndex, checked) {
      this.setCategoriaCheck({ categoriaIndex: catIndex, value: checked });
    },
    autoSelectPrimerServicio() {
      this.categorias.forEach((cat, catIndex) => {
        if (this.categoriaHasMultiselect(cat) && !cat.disabled && !cat.servicioSelected) {
          const options = cat.servicios.length > 0 ? cat.servicios : (this.listaServicios || []);
          if (options.length > 0) {
            this.onCategoriaServicioSelected(catIndex, options[0]);
          }
        }
      });
    },
    cancelarModal() {
      this.selectAll = false;
      this.resetModalTratamiento();
      this.$bvModal.hide('modal-tratamiento');
    },
    async confirmarModal() {
      const OK = await this.guardarLiquidacion();
      if (OK) {
        await this.actualizarInterfaz();
        // Aplicar descuento aquí, cuando totalVenta ya refleja los servicios cargados
        // (evita que vue-numeric lo recorte a 0 por `:max="totalVenta"` cuando era 0)
        const descGral = OK.descuentoGral || this.pendingDescuentoGral;
        const descMonto = OK.descuentoMonto ?? this.pendingDescuentoMonto;
        if (descGral === 1 && descMonto != null) {
          this.setDescuentoGeneral(true);
          this.setDescuento(parseFloat(descMonto));
          await this.actualizarSubTotal();
        }
        this.monto1 = this.getTotalVenta;
        this.cierreConfirmado = true;
        util.showNotify('Guardado correctamente', 'success');
        this.selectAll = false;
        this.resetModalTratamiento();
        this.resetChecks();
        this.$bvModal.hide('modal-tratamiento');
      }
    },
    ...mapActions('modalTratamiento', [
      'resetModalTratamiento',
      'guardarLiquidacion',
      'actualizarInterfaz',
      'fetchPrecioServicioSeleccionado',
    ]),
    ...mapActions('detalleFactura', ['actualizarSubTotal']),
    ...mapActions('modalTratamientoEnCurso', ['resetChecks']),
    ...mapMutations('detalleFactura', [
      'setDescuentoGeneral',
      'setDescuento',
    ]),
    ...mapMutations('modalTratamiento', [
      'toggleExpanded',
      'setServicioCheck',
      'setAllServiciosCheck',
      'setCategoriaServicioSelected',
      'setCategoriaCheck',
      'setActividadEconomicaId',
    ]),
  },
  watch: {
    categorias() {
      this.autoSelectPrimerServicio();
    },
    listaServicios() {
      this.autoSelectPrimerServicio();
    },
  },
  computed: {
    ...mapFields('modalTratamiento', [
      'categorias',
      'isLoading',
      'listaServicios',
      'pendingDescuentoGral',
      'pendingDescuentoMonto',
    ]),
    ...mapFields('formaPagoModal', ['monto1']),
    ...mapFields('modalCierreTratamiento', ['cierreConfirmado']),
    ...mapGetters('detalleFactura', ['getTotalVenta']),
    ...mapGetters('modalTratamientoEnCurso', ['getNumeroItemChecked']),
  },
};
</script>

<style scoped>
.modal-header-internacion {
  background: rgb(186, 233, 255);
}
::v-deep #modal-tratamiento .modal-content {
  overflow: visible !important;
}
::v-deep #modal-tratamiento .modal-body {
  overflow: visible !important;
}
.tr-disabled td {
  opacity: 0.45;
}
.table-servicios {
  font-size: 0.82rem;
}
.table-servicios td {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border: none;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
